<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/training/examination' }">试卷管理</el-breadcrumb-item>
            <el-breadcrumb-item>考试记录</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" size="small" :model="formInline" class="user-search">
            <el-form-item label="员工所属部门：">
                <el-cascader :options="deptTreeList" v-model="formInline.deptIds" clearable filterable
                    :show-all-levels="false" :props="{
                        label: 'deptName', value: 'deptId',
                        checkStrictly: true,
                        multiple: true,
                        emitPath: false,
                    }"></el-cascader>
            </el-form-item>
            <el-form-item label="试卷名称：">
                <el-input size="small" v-model="formInline.examNameLike" :disabled="!!routeQuety.examNameLike"
                    placeholder="请输入试卷名称"></el-input>
            </el-form-item>
            <el-form-item label="员工号：">
                <el-input size="small" v-model="formInline.workNoEq" :disabled="!!routeQuety.workNo"
                    placeholder="请输入员工号"></el-input>
            </el-form-item>
            <el-form-item label="姓名：">
                <el-input size="small" v-model="formInline.userNameLike" :disabled="!!routeQuety.userName"
                    placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="search()">搜索</el-button>
                <el-button size="small" type="primary" @click="exportExcel()">导出考试记录</el-button>
                <el-button size="small" type="primary" @click="goBack()">返回</el-button>
            </el-form-item>
        </el-form>
        <div class="main-table">
            <my-table :columns="tableForm.customColumns" :tableData="tableForm.tableData" :loading="tableForm.isLoading">
                <el-table-column align="center" prop="userSex" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleEdit(scope.$index, scope.row)">考卷详情</el-button>
                    </template>
                </el-table-column>
            </my-table>
        </div>
        <div class="main-pagination">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
        <preview-papers @close="previewDialog.visible = false;" v-bind="previewDialog"
            :detailFn="detailFn"></preview-papers>
    </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import store from '../../vuex/store';
import { capitalEnglishList, fileDownload, organizationName, downloadFile } from "@/utils/util.js";
import courseApi from '@/api/onlineTraining/classification.js'
import { deptTree } from '@/api/dept.js'
import PreviewPapers from '../../components/previewPapers.vue';
import { examResDetail } from '@/api/takeExam.js'
import { examRecordPage } from '@/api/exam.js'
export default {
    components: {
        MyTable,
        Pagination,
        myForm,
        PreviewPapers,
    },
    data () {
        return {
            deptTreeList: [],
            formInline: {
                examPaperId: '',
                examNameLike: '',
                deptIds:[],
                workNoEq: '',
                userNameLike: '',
            },
            tableForm: {
                customColumns: [
                    { label: '所属机构', prop: 'name', formatter: () => { return organizationName } },
                    { label: '员工所属部门', prop: 'deptName' },
                    { label: '试卷名称', prop: 'examName' },
                    { label: '科目类别', prop: 'courseCategoryName' },
                    { label: '试卷总分', prop: 'totalScore' },
                    { label: '总题目数', prop: 'questionNum' },
                    { label: '及格分数', prop: 'passScore' },
                    { label: '及格题目数', prop: 'passNum' },
                    { label: '员工号', prop: 'workNo' },
                    { label: '姓名', prop: 'userName' },
                    { label: '考试开始时间', prop: 'examStartTime' },
                    { label: '考试用时', prop: 'examConsumeTimeDesc' },
                    { label: '实际得分', prop: 'examScore' },
                    { label: '答对题目数', prop: 'examCorrectCount' },
                    { label: '是否补考', prop: 'bkStatus', formatter: (item) => { return item ? '是' : '否' } },
                    { label: '是否合格', prop: 'passStatus', formatter: (item) => { return item ? '是' : '否' } },
                ],
                tableData: [
                ],
                isLoading: false,
            },
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            previewDialog: {
                isPreview: false,
                examId: '',
                visible: false
            },
            routeQuety: {
            }

        }
    },
    created () {
        this.routeQuety = this.$route.query;
        this.formInline.workNoEq = JSON.parse(JSON.stringify(this.$route.query)).workNo;
        this.formInline.userNameLike = JSON.parse(JSON.stringify(this.$route.query)).userName;
        this.formInline.examNameLike = JSON.parse(JSON.stringify(this.$route.query)).examNameLike;
        this.formInline.examPaperId = JSON.parse(JSON.stringify(this.$route.query)).examPaperId;
        this.getDictionary();
        this.getData();
    },
    methods: {
        search () {
            this.pageparm.currentPage = 1;
            this.getData();
        },
        async getData () {
            const params = {
                pageNum: this.pageparm.currentPage,
                pageSize: this.pageparm.pageSize,
                ...this.formInline,
              planId: this.$route.query.planId
            }
            const res = await examRecordPage(params);
            this.tableForm.tableData = res.data.records;
            this.pageparm.total = res.data.total;
        },
        async getDictionary () {
            const deptRes = (await deptTree({ pageNum: 1, pageSize: 999999 })).data;
            this.deptTreeList = deptRes;
        },
        handleEdit (index, row) {
            this.previewDialog.visible = true;
            this.previewDialog.examId = row.examId;
        },
        detailFn () {
            return examResDetail(this.previewDialog.examId)
        },
        callFather (parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize
            this.getData();
        },
        goBack () {
            this.$router.back(-1)
        },
        async exportExcel () {
            downloadFile(await examRecordPage({
                pageNum: 1,
                pageSize: 99999,
                ...this.formInline
            }, {
                responseType: 'blob',
                isExport: true
            }), 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', `考试记录${new Date().getTime()}`);
        }
    }

}
</script>

<style lang="scss" scoped>
.user-search {
    margin-top: 20px;
}

.option-from {
    font-size: 14px;
    margin-bottom: 10px;
    color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/views/training/examinationRecord.vue